<template>
    <md-app>
			<md-app-toolbar style="position: fixed">
				<div class="md-toolbar-row">
					<div class="md-toolbar-section-start">
						<md-button class="md-icon-button" @click="toggleMenu" v-if="is_show_mobile">
							<md-icon>menu</md-icon>
						</md-button>
						<img src="../assets/logo.png" width="24" v-if="!is_show_mobile"/>
						<h3 class="md-title" v-if="!is_show_mobile">Leita</h3>
					</div>
					<TypeFilter/>
					<div class="md-toolbar-section-end">
						<md-menu md-size="medium" md-align-trigger>
							<md-button md-menu-trigger class="md-icon-button">
								<md-icon>more_vert</md-icon>
							</md-button>

							<md-menu-content style="background:white">
								<md-menu-item @click="logout">Log out</md-menu-item>
								<md-menu-item v-show="is_show_extension_link" @click="get_extension">Get extension</md-menu-item>
							</md-menu-content>
						</md-menu>
					</div>
				</div>
			</md-app-toolbar>

      <md-app-drawer
				:md-active.sync="menuVisible"
				md-permanent="clipped"
				style="margin-top:50px; padding: 10px 0 0 10px"
			>
				<TagsFilter style="" />
      </md-app-drawer>

      <md-app-content class="app-area">
				<TabsContainer v-if="!is_editing_tags" />
				<TagEditContainer v-if="is_editing_tags" />
      </md-app-content>
    </md-app>
</template>

<script>
import TabsContainer from '../components/Home/Tabs/TabsContainer'
import TypeFilter from '../components/Home/Filter/TypeFilter'
import TagsFilter from '../components/Home/Filter/TagsFilter.vue'
// import NavBar from '../components/Home/NavBar/NavBar.vue'
// import DialogChromeExtension from '../components/Home/DialogChromeExtension.vue'
// import TagEditDialog from '../components/Home/TagEditDialog.vue'
import TagEditContainer from '../components/Home/TagEditContainer.vue'
import {config} from '../config.js'

export default {
  name: 'home',
  components: {
		TabsContainer,
		TypeFilter,
		TagsFilter,
		// NavBar,
		// DialogChromeExtension,
		TagEditContainer,
		TypeFilter
	},
	computed: {
    is_editing_tags () {
      return this.$store.state.tags.is_editing_tags
		},
		is_show_extension_link () {
			return this.$store.state.user.is_show_extension_link
		},
	},
	data: () => ({
			menuVisible: null,
			is_show_mobile: null
  }),
	methods: {
		toggleMenu () {
			this.menuVisible = !this.menuVisible
		},
		onClick(to) {
			alert(to)
		},
		logout() {
			this.$store.dispatch('user/logout')
		},
		get_extension() {
			const _tab = window.open(config.extension_url, '_blank');
		},
		calc_is_show_mobile() {
			if (window.innerWidth < 600) {
				this.is_show_mobile = true
			} else {
				this.is_show_mobile = false
			}
		}
	},
	mounted: function () {
		document.title = "Leita"
    window.addEventListener('resize', () => {
			this.calc_is_show_mobile()
		})
	},
}
</script>

<style scpped>
#wrapper {
	padding: 0px 0px;
	margin: 0px 20px;
}

.md-app {
	height: 100vh;
	border: 1px solid rgba(#000, .12);
}

.md-drawer {
	width: 230px !important;
}

.app-area {
	background:#fafafa !important;
	padding: 0px !important;
	padding-top:50px !important;
	/* overflow: auto !important; */
	overflow: hidden !important;
}
</style>